<div class="displayFlex">
  <!-- Header -->
  <nz-row class="w-65">
    <nz-col nzSpan="15" class="header-title">
      <div>
        <h4 class="text-left color-gray">
          {{ trackReport.trackVSMaximoEquipmentVariance }}
        </h4>
        <h6 class="text-left subtitle">{{ trackReport.allData }}</h6>
      </div>
    </nz-col>
    <nz-col nzSpan="9">
      <div>
        <table class="w-auto">
          <tr>
            <td>
              <b>{{ trackReport.contractor }}:</b>
            </td>
            <td class="text-left">{{ reportData.contractor }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ trackReport.workDate }}:</b>
            </td>
            <td class="text-left">{{ reportData.date }}</td>
          </tr>
        </table>
      </div>
    </nz-col>
  </nz-row>

  <!-- Data -->
  <nz-row class="w-65 bgcolor-gray">
    <!-- Spinner -->
    @if (!trackMXVareQResponse) {
      <div class="item-center mt-5 w-100">
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
          diameter="50"
        ></mat-progress-spinner>
      </div>
    }
    @if (trackMXVareQResponse) {
      <table
        class="m-15 table table-bordered table-striped"
        >
        <tr class="table-header-1">
          <td></td>
          <td colspan="3" class="text-center text-red">
            <b>{{ trackReport.hours | uppercase }}</b>
          </td>
        </tr>
        <tr class="table-header-2">
          <td class="text-left text-red" nzSpan="1">
            <b>{{ trackReport.resources }}</b>
          </td>
          <td class="text-red">
            <b>{{ trackReport.track }}</b>
          </td>
          <td class="text-red">
            <b>{{ trackReport.maximo }}</b>
          </td>
          <td class="text-red">
            <b>{{ trackReport.variance }}</b>
          </td>
        </tr>
        @for (res of trackMXVareQResponse; track res) {
          <tr class="bgcolor-gray-dark">
            <td colspan="4" class="text-left pl-2 wonum-block">
              <nz-row>
                <nz-col nzSpan="5">
                  <b>{{ res.workOrder }}</b>
                </nz-col>
                <nz-col nzSpan="19">
                  {{ res.woDescription }}
                </nz-col>
              </nz-row>
            </td>
          </tr>
          <tbody>
            @for (item of res.trackMXVarEQList; track item) {
              <tr>
                <td class="text-left">{{ item.name }}</td>
                <td>{{ item.trackHrs | decimalRound }}</td>
                <td>{{ item.maxHrs | decimalRound }}</td>
                <td>{{ item.varHrs | decimalRound }}</td>
              </tr>
            }
          </tbody>
          <tr class="bg-white">
            <td></td>
            <td>
              <b>{{ res.sumTrackHrs | decimalRound }}</b>
            </td>
            <td>
              <b>{{ res.sumMaxHrs | decimalRound }}</b>
            </td>
            <td>
              <b>{{ res.sumVarHrs | decimalRound }}</b>
            </td>
          </tr>
        }
        <tr class="bgcolor-yellow">
          <td class="text-left pl-2">
            <b>{{ companyName }} {{ trackReport.stotals }}:</b>
          </td>
          <td>
            <b class="bg-white total-p">{{ totalTrackSum | decimalRound }}</b>
          </td>
          <td>
            <b class="bg-white total-p">{{ totalMaxSum | decimalRound }}</b>
          </td>
          <td>
            <b class="bg-white total-p">{{ totalVarSum | decimalRound }}</b>
          </td>
        </tr>
        <tr class="bgcolor-yellow">
          <td colspan="4" class="footer-note">
            <b>{{ trackReport.totalVarianceTxt }}</b>
          </td>
        </tr>
      </table>
    }
  </nz-row>
</div>
